import {useSuspenseQuery} from "@apollo/client";
import {Helmet} from "react-helmet-async";
import {Link, Navigate, useParams} from "react-router";

import Button from "@/components/button/Button.tsx";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {CheckRTASummaryResponse, GQL_CHECK_DETAILS, GQL_CHECK_RTA_SUMMARY} from "@/lib/queries/checks.ts";
import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {CheckDetailsActions} from "@/pages/checks/analysis/actions/CheckDetailsActions.tsx";
import {AlertsList} from "@/pages/checks/rta/components/AlertsList.tsx";
import {ServiceSummary} from "@/pages/checks/rta/components/ServiceSummary.tsx";
import {StatusPerLocation} from "@/pages/checks/rta/components/StatusPerLocation.tsx";
import {Traceroute} from "@/pages/checks/rta/components/Traceroute.tsx";

export const RTAContent = () => {
  const {id} = useParams();
  const checkId = parseInt(id!);

  const {
    data: {service, statusPerLocation, monitoringServers},
  } = useSuspenseQuery<CheckRTASummaryResponse>(GQL_CHECK_RTA_SUMMARY, {
    variables: {id: checkId},
  });

  if (service.monitoring_service_type === MonitoringServiceType.GROUP) {
    return <Navigate to={`/checks/group/${checkId}`} />;
  }

  return (
    <ContentContainer
      title="Real-Time Analysis"
      actionsBar={
        <CheckDetailsActions
          id={service.id}
          publicURL={service.public_check_details_url}
          checkType={service.monitoring_service_type}
        >
          <Button
            as={Link}
            to={`/checks/${service.id}/edit`}
            size={"large"}
            state={{
              refetchQueries: [GQL_CHECK_DETAILS],
            }}
          >
            Edit Check
          </Button>
        </CheckDetailsActions>
      }
    >
      <Helmet>
        <title>Real-Time Analysis: {service.name}</title>
      </Helmet>
      <div className="row">
        <div className="col-lg-12 my-2">
          <ServiceSummary service={service} />
        </div>
      </div>
      <StatusPerLocation service={service} statusPerLocation={statusPerLocation} />
      <AlertsList service={service} statusPerLocation={statusPerLocation} />
      <Traceroute className="mb-2 rounded border" service={service} monitoringServers={monitoringServers} />
    </ContentContainer>
  );
};
